import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const PickupPieceResponseSchema = z.object({
  serviceCode: z.string().optional(),
  quantity: z.string().optional(),
  destinationCountryCode: z.string().optional(),
  containerCode: z.string().optional(),
});

const PickupAddressResponseSchema = z.object({
  companyName: z.string().optional(),
  contactName: z.string().optional(),
  addressLine: z.string().optional(),
  city: z.string().optional(),
  stateProvince: z.string().optional(),
  postalCode: z.string().optional(),
  countryCode: z.string().optional(),
  phoneNumber: z.string().optional(),
});

const PendingPickupSchema = z.object({
  pickupRequestNumber: z.string(),
  pickupDate: z.string(),
  readyTime: z.string().optional(),
  closeTime: z.string().optional(),
  pickupAddress: PickupAddressResponseSchema.optional(),
  pickupPieces: z.array(PickupPieceResponseSchema).optional(),
  totalWeight: z
    .object({
      weight: z.string().optional(),
      unitOfMeasurement: z.string().optional(),
    })
    .optional(),
  status: z.string().optional(),
});

export const getPendingUpsPickups = {
  name: "getPendingUpsPickups" as const,
  input: z.object({
    teamId: zExt.objectId(),
    pickupType: z.enum(["oncall", "smart", "both"]).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    pickups: z.array(PendingPickupSchema),
    error: z.string().optional(),
  }),
};
